import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import utilityStyles from '@lichtblick/photon/theme/utilities.module.scss';
import classNames from 'classnames';
import styles from './steps.module.scss';
export const Step = ({ theme, icon: Icon, text })=>/*#__PURE__*/ _jsx("li", {
        className: styles.step,
        children: /*#__PURE__*/ _jsxs("div", {
            className: classNames(styles['step-content'], utilityStyles[`theme-bg-${theme || 'white'}`]),
            children: [
                /*#__PURE__*/ _jsx(Icon, {}),
                /*#__PURE__*/ _jsx(Text, {
                    bold: true,
                    size: "s",
                    children: text
                })
            ]
        })
    });
export const Steps = ({ children })=>/*#__PURE__*/ _jsx("ul", {
        className: styles.steps,
        children: children
    });

//# sourceMappingURL=Steps.js.map